import * as React from "react"
import { theme } from "../theme.css"
import * as styles from "./red-alert.css"
import { default as allRedAlertNewsPosts } from "../staticQueries/allRedAlertNewsPosts"
import { TPost } from "../types"

import {
  NavLink,
} from "./ui"

export default function RedAlert() {

  const alertPosts: TPost[] = allRedAlertNewsPosts()

  return (
   <>
      { 
        alertPosts && alertPosts.length > 0 && 
        <div className={styles.alertPanel}>
          {alertPosts.slice(0,1).map(alertPost => {
            return (
              <div key={alertPost.id} className={styles.alertContent}>
                <div className={styles.alertTitle}>{alertPost?.title}</div>
                <div>{alertPost?.summary}</div>
                <NavLink to={`/news/${alertPost.slug}`} className={styles.alertButton}>read more</NavLink>
              </div>
            )
          })
        }
        </div>
      }
   </>
  )
}
